/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type CaretContainer_settings = {
    readonly " $fragmentRefs": FragmentRefs<"ModerationDropdownContainer_settings">;
    readonly " $refType": "CaretContainer_settings";
};
export type CaretContainer_settings$data = CaretContainer_settings;
export type CaretContainer_settings$key = {
    readonly " $data"?: CaretContainer_settings$data;
    readonly " $fragmentRefs": FragmentRefs<"CaretContainer_settings">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "CaretContainer_settings",
    "selections": [
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ModerationDropdownContainer_settings"
        }
    ],
    "type": "Settings",
    "abstractKey": null
} as any);
(node as any).hash = 'c5fbf91af1e17c35427e318a95ce13e1';
export default node;
